import { ComponentStyleConfig } from "@chakra-ui/react";

export const numberInputTheme: ComponentStyleConfig = {
  defaultProps: {
    colorScheme: "brand",
    focusBorderColor: "brand.300",
  },
};
